import * as types from '../actions/types'

const initialState = {
  isOpen: true,
  oldIsOpen: true,
  newIsOpen: true
}

export default function (state=initialState, action) {

  switch (action.type) {
    case types.TOGGLE_SIDEBAR:
      return Object.assign({}, state, {
        isOpen: !state.isOpen
      })

    case types.TOGGLE_CATEGORY:
      const property = `${action.category}IsOpen`
      return Object.assign({}, state, {
        [property]: !state[property]
      })

    default:
      return state
  }
}

// {...state, isPlaying: true} is same as:
// Object.assign({}, state, {
//   isPlaying: true
// })



// WEBPACK FOOTER //
// ./src/reducers/sidebar.js